import type { ApiResponse } from '@shared/types'
import type { AxiosError } from 'axios'
import { getErrorText } from 'v2/shared/utils/api-error-text'

const INCORRECT_CODE_MESSAGE = 'Incorrect code. Please try again or request a new one.'

// hodor answers a wrong code with "Invalid OTP token" (phone) or "Invalid OTP" (authenticator).
export const getTwoFactorVerifyErrorText = (err: AxiosError<ApiResponse<unknown>>) => {
  const globalError = err.response?.data?.errors?.global_error
  if (typeof globalError === 'string' && globalError.startsWith('Invalid OTP')) {
    return INCORRECT_CODE_MESSAGE
  }
  return getErrorText(err)
}
